module.exports = __webpack_public_path__ + "static/3dmodel02-43e391570d97744f0fc4928abc15e449.jpg";